import { render, staticRenderFns } from "./TooltipAjuda.vue?vue&type=template&id=02d36341&lang=html"
import script from "./TooltipAjuda.vue?vue&type=script&lang=js"
export * from "./TooltipAjuda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports